import React from "react";

import "./button.css";

const Button = ({ link, children, ...props }) => {
  return (
    <a {...props} className="btn-svg" href={link}>
      {children}
    </a>
  );
};

export default Button;
